import { INSTANT_EPRICE } from '../global-constants.js';
import { ddcLog } from '../utils/logger.js';
import { getPricingFacetMarkup } from './markup.js';
import {
	getPaymentData,
	getPaymentContent
} from './payments/index.js';

const clearExistingContent = async (elem, isNewComparePage) => {
	if (!elem || elem.length === 0) {
		return;
	}
	
	const walletElem = isNewComparePage ? elem.parentNode : elem;
	// Clean up existing payments after the user changes their wallet settings while on an already-rendered SRP or VDP.
	const existingContent = walletElem.querySelectorAll('[data-web-api-inserted="true"]');
	existingContent.forEach(content => {
		content.remove();
	});
}

export const insertOrUpdatePricingPlacements = async (API, isSRP, walletData, config, dealerData, isNewComparePage, eventData) => {
	const {
		paymentDataSource,
		paymentDisclaimer,
	} = config;

	const pageData = await API.utils.getPageData();
	const { layoutType } = pageData;
	const isMobile = layoutType === 'mobile';
	const isGridLayout = document.querySelector('.vehicle-card-grid') || (isSRP && isMobile);

	const vehiclePaymentsCallback = async (elem, vehicle) => {
		let ePriceData = null;
		if (eventData?.type === INSTANT_EPRICE) {
			if (eventData?.uuid !== vehicle?.uuid) {
				// target specific eprice vehicle to recalculate payment using eprice data
				ddcLog('DDC: INSTANT_EPRICE SKIP payment calculation for vehicle: ', vehicle?.uuid);
				return;
			}
			ddcLog('DDC: INSTANT_EPRICE re-calculate payment using eprice data: ', vehicle?.uuid);
			ePriceData = {
				...eventData,
			}
		}
		const isNewCarBoostPayment = (vehicle?.priorityType === 'ncb') ??
				(elem.parentNode.getAttribute('data-location') === 'vehicle-payments-primary' &&
				elem.parentNode.getAttribute('data-vehicle-new-car-boost') === 'true');
		
		const paymentData = await getPaymentData(API, paymentDataSource, vehicle, config, dealerData, walletData, ePriceData, isNewCarBoostPayment);
		if (paymentData?.noResult) {
			clearExistingContent(elem, isNewComparePage);
		} else {
			const paymentMarkup = getPaymentContent(
				config, paymentData, vehicle, paymentDisclaimer, isGridLayout,
				isSRP, walletData, isMobile, isNewCarBoostPayment, isNewComparePage
			);
			clearExistingContent(elem, isNewComparePage);
			if (paymentMarkup) {
				API.append(elem, paymentMarkup);
			}
		}
	};

	// Decorate VDP and SRP (simplified listing expanded payment view
	// with monthly payment values and 'Payment Settings' link.
	API.insertOnce('vehicle-payments', vehiclePaymentsCallback);

	if (isSRP) {
		// For the grid and mobile SRPs, also add the monthly payment / link between the primary vehicle price and the tabs below.
		API.insertOnce('vehicle-payments-primary', vehiclePaymentsCallback);
	}
}


export const insertOrUpdateFacetPlacement = async (API, config) => {
	// Add markup below the pricing facet on the SRP.
	if (config?.showFacetsPlacement) {
		API.insert('search-facet-pricing', async (elem) => {
			const markup = await getPricingFacetMarkup(config);
			clearExistingContent(elem);
			API.append(elem, markup);
		});
	}
}
